import * as styledElements from "./AddressInfoStyles";
import { ShippingAddress } from "../../../reducers/uploadedBoard";
import { formatReadablePhoneNumber } from "../../../utils/valueFormatting";

const AddressInfo = ({
  address,
  asRadioButtonLabel,
}: {
  address: ShippingAddress;
  asRadioButtonLabel?: boolean;
}) => {
  const formattedPhone =
    formatReadablePhoneNumber(address.phone_number) || address.phone_number;
  return (
    <styledElements.AddressText asRadioButtonLabel={asRadioButtonLabel}>
      <div>{address.name}</div>
      {address.company_name && <div>{address.company_name}</div>}
      <div>{address.address_line_1}</div>
      {address.address_line_2 && <div>{address.address_line_2}</div>}
      <div>{`${address.city}, ${address.state} ${address.postal_code}`}</div>
      {formattedPhone && <div>{formattedPhone}</div>}
    </styledElements.AddressText>
  );
};

export default AddressInfo;
